import type { Context } from "react";
import { useContext as useContextBase } from "react";

import { DEFAULT_VALUE, ERROR_MESSAGE } from "./constants";

export const useContext = <ValueType>(context: Context<ValueType>) => {
	const contextValue = useContextBase(context);

	if (contextValue === DEFAULT_VALUE) {
		throw new Error(ERROR_MESSAGE);
	}

	return contextValue;
};
